import { Component, Input } from '@angular/core';
import { UserPreview } from '../../../shared/interfaces/user-preview.interface';
import { BaseClass } from '../../../shared/classes/base';
import { ToastController } from '@ionic/angular';
import { TranslationService } from '../../../shared/services/translation.service';

@Component({
  selector: 'app-subordinate-profile',
  templateUrl: './subordinate-profile.component.html',
  styleUrls: ['./subordinate-profile.component.scss'],
})
export class SubordinateProfileComponent extends BaseClass {
  @Input() user: UserPreview;
  @Input() getImageUrl: (url?: string) => string;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
  ) {
    super(_toastController, _translationService);
  }
}
